import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const submitInquiry = (data) => api.post("/inquiries", data).then((r) => r.data);
export const submitPartnership = (data) => api.post("/partnerships", data).then((r) => r.data);
